import { combineReducers } from "redux";

import IntroReducer from "./introReducer";
import AuthReducer from "./authReducer";
import ModalsReducer from "./modalsReducer";

// arguments to combineReducers represent objects in the state and their respective reducers
export default combineReducers({
  intros: IntroReducer,
  auth: AuthReducer,
  modals: ModalsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js